import { FunctionComponent, useEffect, useState } from "react";
import "./styles.scss";
import Label from "../Label";

type Props = {
  pages: number;
  handleSelectPage: (value: number) => void;
  selectedPage: number; // initialize state to 1
};

const Paginator: FunctionComponent<Props> = ({
  pages,
  handleSelectPage,
  selectedPage,
}) => {
  const [paginatorPages, setPaginatorPages] = useState<number[]>([]);

  useEffect(() => {
    let calculatedPages = [];
    if (pagesContainer.length > 5) {
      for (let index = selectedPage - 1; index < selectedPage + 5; index++) {
        pagesContainer[index] && calculatedPages.push(pagesContainer[index]);
      }
    } else {
      calculatedPages = pagesContainer;
    }
    setPaginatorPages(calculatedPages);
  }, [pages, selectedPage]);

  const handleNextClick = () => {
    if (selectedPage < pages) {
      handleSelectPage(selectedPage + 1);
    }
  };

  const handlePrevClick = () => {
    if (selectedPage > 1) {
      handleSelectPage(selectedPage - 1);
    }
  };

  const handlePageClick = (page: number) => {
    handleSelectPage(page);
  };

  const pagesContainer = Array.from({ length: pages }).reduce(
    (arr: number[], x, indice) => {
      arr.push(indice + 1);
      return arr;
    },
    []
  );

  return (
    <section className="paginator">
      <Label
        tag="p"
        variants="body1"
        style={{ color: "black" }}
        className="paginator__title"
      >
        Páginas
      </Label>
      <div className="paginator__container">
        <a onClick={handlePrevClick}>&lt;</a>
        {selectedPage > 4 && (
          <div
            key={pagesContainer[0]}
            className="page__container"
            onClick={() => handlePageClick(pagesContainer[0])}
          >
            <Label
              tag="p"
              variants="body1"
              className="page"
            >{`${pagesContainer[0]} ...`}</Label>
            {selectedPage === pagesContainer[0] && (
              <hr className="page__selector" />
            )}
          </div>
        )}
        {paginatorPages.map((page, index) => (
          <div
            key={index}
            className="page__container"
            onClick={() => handlePageClick(page)}
          >
            <Label tag="p" variants="body1" className="page">{`${page}`}</Label>
            {selectedPage === page && <hr className="page__selector" />}
          </div>
        ))}
        <a onClick={handleNextClick}>&gt;</a>
      </div>
    </section>
  );
};

export default Paginator;
